import api from '../client';

/**
 * Service de gestion des paramètres d'organisation.
 * Couvre notamment la passerelle SMS Mobile Money (MTN MoMo / Orange Money).
 */
const settingsService = {
  /**
   * Génère (ou régénère) le token de passerelle SMS de l'organisation.
   * Le token est retourné EN CLAIR une seule fois — à copier immédiatement dans l'app Android.
   * @returns {{ token: string, webhookUrl: string, instructions: string[] }}
   */
  generateGatewayToken: async () => {
    const response = await api.post('/settings/sms-gateway/token');
    return response.data;
  },

  /**
   * Retourne l'état du token actuel (masqué) et l'URL webhook à configurer.
   * @returns {{ hasToken: boolean, maskedToken?: string, webhookUrl?: string }}
   */
  getGatewayTokenInfo: async () => {
    const response = await api.get('/settings/sms-gateway/token');
    return response.data;
  },

  /**
   * Révoque le token de passerelle SMS.
   * L'app Android enverra des 401 jusqu'à reconfiguration.
   */
  revokeGatewayToken: async () => {
    const response = await api.delete('/settings/sms-gateway/token');
    return response.data;
  },
};

export default settingsService;
